import { render, staticRenderFns } from "./paginationVue.vue?vue&type=template&id=a6ed9c5e&scoped=true&"
import script from "./paginationVue.vue?vue&type=script&lang=js&"
export * from "./paginationVue.vue?vue&type=script&lang=js&"
import style0 from "./paginationVue.vue?vue&type=style&index=0&id=a6ed9c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ed9c5e",
  null
  
)

export default component.exports